const LEGACY_PREFIX = 'quazi-aml-xlsx-import-draft:';

/** Remove leftover browser drafts from the first localStorage version. */
export function clearLegacyImportDrafts(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(LEGACY_PREFIX)) keys.push(key);
    }
    keys.forEach((key) => localStorage.removeItem(key));
  } catch {
    /* ignore */
  }
}
